"use client";

// Небольшой синглтон «активная вкладка портала». Отдел/модуль-страницы
// (departments-workspace) публикуют сюда лейбл вкладки, на которой стоит сотрудник,
// а AI-ассистент читает его при отправке — чтобы понимать не только отдел (из
// pathname), но и конкретную вкладку («что на этой вкладке»). Синглтон, потому что
// страница отдела и плавающая панель FAB живут в разных ветках дерева.

let current = "";
const listeners = new Set<() => void>();

export function setActiveView(v: string): void {
  const nv = (v || "").trim();
  if (nv === current) return;
  current = nv;
  listeners.forEach((l) => l());
}

export function getActiveView(): string {
  return current;
}

export function subscribeActiveView(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
